window.add_event = async function(calendar, startdate, duration, title, hint, route, color, font_color, published){
    var date = new Date(startdate);
    var lastday = new Date(date.getUTCFullYear(), date.getMonth() + 1, 0).getDate();
    for (var i = 1; i <= duration; i++ ){
        var day = date.getDate();
        var edate = $('.' + calendar.id + '-' + (date.getMonth() + 1) + '-' + day)[0];
        if (!edate) return;
        edate.title = title;
        if (i === 1){
            var hint_div = document.createElement("div");
            hint_div.classList.add('hint');
            hint_div.innerHTML = hint;
            hint_div.style.color = color;
            edate.append(hint_div);
        }

        var layer = document.createElement("div");
        layer.classList.add('layer');
        layer.style.backgroundColor = color;
        edate.classList.add('event');
        if (published){
            edate.classList.add('published');
            edate.addEventListener("click", function(e) {
                location.href = '/' + route;
            }, false);
        }
        var wday = date.getDay();
        if (i === 1 || wday === 1 || day === 1)
            layer.classList.add('left');
        if (i === duration || wday === 0 || day == lastday)
            layer.classList.add('right');
        date.setDate(date.getDate() + 1);
        edate.append(layer);
    }
};

window.loadCalendar = function(events){
    var calendar = document.getElementById('calendar');
    if (!calendar) return;
    events.forEach(event => {
        window.add_event(calendar,
            event.startdate,
            event.duration,
            event.title,
            event.distance,
            event.route,
            event.color,
            event.font_color,
            event.published);
    });
};
